import React from 'react'

import { Stamp, Tooltip } from './style'

export default ({ daInfo = false }) => (
  <Stamp daInfo={daInfo}>
    <Tooltip>0KM</Tooltip>
  </Stamp>
)
